export const handleChangeDataModalStory = (name, value) => ({
    type: 'CHANGE_DATA_MODAL_STORY', name, value
});